<div #blockElement [ngClass]="blockClasses">
  <div class="gallery-text-block__container">
    @if (textContent) {
      <div [ngClass]="contentClasses">
        @for (segment of textSegments; track $index) {
          <span class="gallery-text-block__segment" [style.transition-delay.ms]="getSegmentDelay($index)">
            {{ segment }}
          </span>
        }
      </div>
    } @else {
      <!-- Fallback if text content is somehow empty -->
      <div class="gallery-text-block__content text-muted">
        <p><i>Editorial text section is empty.</i></p>
      </div>
    }
  </div>
</div>
